import Ajax from '@/lib/ajax'

export default {
  /**
   * 获取定时上架任务列表
   */
  getTimeTaskList(currentPage: number, pageSize: number, obj: any) {
    let params = {
      SkipCount: (currentPage - 1) <= 0 ? 0 : (currentPage - 1) * pageSize,
      MaxResultCount: pageSize
    }
    if(obj.keyWord) {
      params['KeyWord'] = obj.keyWord
    }
    if(obj.begin) {
      params['Begin'] = obj.begin
    }
    if(obj.end) {
      params['End'] = obj.end
    }
    if(obj.taskState) {
      params['TaskState'] = obj.taskState
    }
    return Ajax.get(`/api/productManagement/ProductTimeTask`, {
      params
    })
  },
  /**
   * 新增商品定时任务
   */
  postTimeTask(obj: any) {
    return Ajax.post(`/api/productManagement/ProductTimeTask`, obj)
  },
  /**
   * 删除商品定时上架任务
   */
  deleteTimeTask(ids: any) {
    const text = ids.join("&ids=");
    return Ajax.delete(`/api/productManagement/ProductTimeTask`, {
      params: {
        ids
      }
    });
  },
  /**
   * 获取商品定时上架详情
   */
  getTimeTaskDetail(id: string) {
    return Ajax.get(`/api/productManagement/ProductTimeTask/${id}`)
  },
  /**
   * 更新商品定时上架详情
   */
  updateTimeTaskDetail(id: string, obj: any) {
    return Ajax.put(`/api/productManagement/ProductTimeTask/${id}`, obj)
  }
}